"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deserializeSentenceResult = exports.serializeSentenceResult = void 0;
var SentenceResult_1 = require("../../results/SentenceResult");
function serializeSentenceResult(result) {
    return {
        sentences: result.sentences,
        responses: result.responses,
        expected_responses: result.expectedResponses,
        reading_times: result.readingTimes,
        average_rt_millis: result.averageRTMillis,
        number_correct: result.numberCorrect,
        speed_errors: result.speedErrors,
    };
}
exports.serializeSentenceResult = serializeSentenceResult;
function deserializeSentenceResult(result) {
    var sentenceResult = new SentenceResult_1.SentenceResult();
    sentenceResult.sentences = result.sentences;
    sentenceResult.responses = result.responses;
    sentenceResult.expectedResponses = result.expected_responses;
    sentenceResult.readingTimes = result.reading_times;
    sentenceResult.averageRTMillis = result.average_rt_millis;
    sentenceResult.numberCorrect = result.number_correct;
    sentenceResult.speedErrors = result.speed_errors;
    return sentenceResult;
}
exports.deserializeSentenceResult = deserializeSentenceResult;
